import React from 'react'
import { toJS } from 'mobx'
import { observer } from 'mobx-react'
import Joyride from 'react-joyride'

// options.style uses react-joyride v1's per-step style shape
// ({ display, width, main: { padding, marginLeft, marginRight } }),
// which is set in several places in UIStore.js. Rather than rewrite
// every caller, translate that shape into v2's `styles` prop here.
// Clone to plain objects: React freezes `style` on DOM nodes, and MobX
// throws if those objects are still dynamic observables.
const joyrideStyles = (style = {}) => {
  const plain = style ? toJS(style) : {}
  const main = plain.main ? { ...toJS(plain.main) } : {}
  return {
    options: {
      arrowColor: 'transparent',
      backgroundColor: '#FFFFFF',
      overlayColor: 'transparent',
      primaryColor: '#24283E',
      textColor: '#1E293B',
      zIndex: 100000
    },
    tooltip: {
      borderRadius: '12px',
      padding: 0,
      backgroundColor: '#FFFFFF',
      boxShadow: '0 10px 30px rgba(0, 0, 0, 0.14), 0 2px 8px rgba(0, 0, 0, 0.06)',
      border: '1px solid rgba(0, 0, 0, 0.08)',
      overflow: 'visible',
      ...(plain.width ? { width: plain.width } : { width: 360 })
    },
    tooltipContainer: {
      padding: 0,
      textAlign: 'left'
    },
    tooltipContent: {
      padding: 0,
      ...main
    }
  }
}

const Tooltip = ({ options, id }) => {
  const offsetVal = options.offset !== undefined ? options.offset : 12
  const placement = options.position || 'right-start'
  const floaterOptions = {
    disableFlip: true,
    hideArrow: true,
    offset: offsetVal,
    ...options.floaterProps
  }

  return (
    <div id={id}>
      <Joyride
        steps={[{
          content: options.text,
          target: options.selector || '.tools.popup-menu',
          placement,
          isFixed: true,
          disableBeacon: true,
          hideFooter: true,
          offset: offsetVal,
          styles: joyrideStyles(options.style),
          floaterProps: floaterOptions
        }]}
        run
        disableOverlay
        hideCloseButton
        spotlightPadding={0}
        styles={joyrideStyles(options.style)}
        floaterProps={floaterOptions}
      />
    </div>
  )
}

export default observer(Tooltip)
